module.exports = __webpack_public_path__ + "static/media/James-wong-article-thumbnail.d94d8e11.jpg";